// extracted by mini-css-extract-plugin
module.exports = {"uxSignalsWidget":"UxSignalsWidget_uxSignalsWidget__UGwDx"};